import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { getWeddingPageByTypeV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import Hero from './Home/Hero';
import NameSectionMiddle from './Home/NameSectionMiddle';
import RightNameSection from './Home/RightNameSection';
import LeftNameSection from './Home/LeftNameSection';
import SealSection from './Home/SealSection';

class Home extends Component {
  componentDidMount() {
    const { getHomepageSectionEntities, forPreview } = this.props;
    if (!forPreview) {
      getHomepageSectionEntities();
    }
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  handleScroll() {
    this.pageBody.scrollIntoView();
  }

  render() {
    const { homepageSections, orderedIds, wedding, page, forPreview, busy } = this.props;
    const weddingDate = wedding.wedding_date && moment.utc(wedding.wedding_date);
    const headerStyle = page.header_image_url ? { backgroundImage: `url(${page.header_image_url}?h=700)` } : {};
    const footerStyle = page.footer_image_url ? { backgroundImage: `url(${page.footer_image_url}?h=700)` } : {};
    const welcomeMessage = page.title;
    return (
      <div className={(page.title && !(page.header_image_url)) ? 'public-page offset-background-image' : 'public-page'}>
        {page && !busy && (wedding.wedding_account_id || wedding.account_id)
        && (
        <div>
          {(page.header_image_url || page.title)
            && <Hero page={page} wedding={wedding} headerStyle={headerStyle} handleScroll={this.handleScroll} />
          }
          <div className={[`page-content${(forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && homepageSections && homepageSections.length === 0) ? ' no-entities' : ' has-entities'} ${page.header_image_url ? 'has-image' : 'no-image-above'}`, !welcomeMessage ? 'no-welcome-message' : 'has-welcome-message'].join(' ')}>
            <div className="page-accent-top-left" />
            <div className="page-accent-top-right" />
            <div className="page-accent-bottom-left" />
            <div className="page-accent-bottom-right" />
            {wedding.owner_first_name && wedding.partner_first_name && wedding.enable_seal ? (
              <SealSection topSeal wedding={wedding} />
            ) : (
              null
            )}
            <div className="names-section" ref={(elem) => { this.pageBody = elem; }}>
              <div className="names-accent-top-left" />
              <div className="names-accent-top-right" />
              <div className="names-accent-bottom-left" />
              <div className="names-accent-bottom-right" />
              <LeftNameSection wedding={wedding} />
              <NameSectionMiddle wedding={wedding} />
              <RightNameSection wedding={wedding} />
            </div>
            {(weddingDate || (wedding.city || wedding.state_province))
            && (
            <div className="wedding-info-section">
              <div className="horizontal">
                {wedding.hashtag
                && (
                <div className="hashtag">
                  <h4>
                    #{wedding.hashtag}
                  </h4>
                </div>
                )
                }
                <div className="content">
                  {(wedding.city || wedding.state_province)
                  && (
                  <div className="location">
                    <h4 className="in">in</h4>
                    <h3>
                      {wedding.city && <span className="city">{wedding.city}</span>}
                      {wedding.state_province && wedding.city && <span className="comma">, </span>}
                      {wedding.state_province && <span className="state">{wedding.state_province}</span>}
                    </h3>
                  </div>
                  )
                  }
                  {weddingDate
                  && (
                  <div className="date">
                    <span>
                      <h4 className="on">on</h4>
                      <h3>
                        <span className="month">{weddingDate.format('MMMM')}</span>
                        <span className="day">{weddingDate.format('D')}</span>
                        <span className="year">{weddingDate.format('YYYY')}</span>
                      </h3>
                    </span>
                  </div>
                  )
                  }
                </div>
              </div>
              <div className="vertical-single">
                <div className="name-1 hidden-xs">
                  <div className="initials">
                    {wedding.owner_first_name && <span className="initial-1">{wedding.owner_first_name[0]}</span>}
                    {wedding.owner_first_name && wedding.owner_last_name && <div className="accent" />}
                    {wedding.owner_last_name && <span className="initial-2">{wedding.owner_last_name[0]}</span>}
                  </div>
                </div>
                <div className="info-section">
                  <div className="content">
                    {wedding.hashtag
                    && (
                    <div className="hashtag">
                      <h4>
                        #{wedding.hashtag}
                      </h4>
                    </div>
                    )
                    }
                    {weddingDate
                    && (
                    <div className="date-wrapper">
                      <h3 className="date">
                        <div className="month">
                          <span className="numeric">
                            {weddingDate.format('M')}
                          </span>
                          <span className="word">
                            {weddingDate.format('MMMM')}
                          </span>
                        </div>
                        <span className="day">
                          {weddingDate.format('D')}
                        </span>
                        <div className="year">
                          <span className="full">
                            {weddingDate.format('YYYY')}
                          </span>
                          <span className="minimal">
                            {weddingDate.format('YY')}
                          </span>
                        </div>
                      </h3>
                    </div>
                    )
                    }
                    {(wedding.city || wedding.state_province)
                    && (
                    <h4 className="location">
                      {wedding.city && wedding.city}{wedding.state_province && wedding.city && ', '}{wedding.state_province && wedding.state_province}
                    </h4>
                    )
                    }
                  </div>
                </div>
                <div className="name-2 hidden-xs">
                  <div className="initials">
                    {wedding.partner_first_name && <span className="initial-1">{wedding.partner_first_name[0]}</span>}
                    {wedding.partner_first_name && wedding.partner_last_name && <div className="accent" />}
                    {wedding.partner_last_name && <span className="initial-2">{wedding.partner_last_name[0]}</span>}
                  </div>
                </div>
              </div>
              <div className="vertical-double">
                {(wedding.owner_first_name && wedding.partner_first_name)
                && (
                <div className="wedding-info-column wedding-info-left">
                  {(wedding.city || wedding.state_province)
                  && (
                  <h4 className="location">
                    {wedding.city && wedding.city}{wedding.state_province && wedding.city && ', '}{wedding.state_province && wedding.state_province}
                  </h4>
                  )
                  }
                  <span className="big-initial">{wedding.owner_first_name[0]}</span>
                  <h4 className="and">and</h4>
                  <span className="big-initial">{wedding.partner_first_name[0]}</span>
                  {wedding.hashtag && <h4 className="hashtag">#{wedding.hashtag}</h4>}
                </div>
                )
                }
                {weddingDate
                && (
                <div className="wedding-info-column wedding-info-right">
                  <h4 className="day-month">{weddingDate.format('dddd')}</h4>
                  <span className="big-initial day">{weddingDate.format('M')}</span>
                  <h4>/</h4>
                  <span className="big-initial month">{weddingDate.format('D')}</span>
                  <h4>{weddingDate.format('YYYY')}</h4>
                </div>
                )
                }
              </div>
            </div>
            )
            }
            {((forPreview && orderedIds && orderedIds.length > 0) || (!forPreview && homepageSections && homepageSections.length > 0))
            && (
            <div className="entity-sections homepage-sections clearfix">
              {forPreview && homepageSections && orderedIds.map(homepageSectionId => (
                <div className="entity-section homepage-section clearfix" key={homepageSectionId}>
                  <div className="entity-section-title homepage-section-title">
                    <h2 className="section-title">{homepageSections[homepageSectionId].title}</h2>
                    {homepageSections[homepageSectionId].subtitle
                    && <h4 className="section-subtitle">{homepageSections[homepageSectionId].subtitle}</h4>}
                  </div>
                  <div className="entity-section-description homepage-section-description">
                    <p>{homepageSections[homepageSectionId].description}</p>
                  </div>
                  <div className="section-accent" />
                </div>
              ))}
              {!forPreview && homepageSections && homepageSections.map((homepageSection, idx) => (
                <div className="entity-section homepage-section clearfix" key={idx}>
                  <div className="entity-section-title homepage-section-title">
                    <h2 className="section-title">{homepageSection.title}</h2>
                    {homepageSection.subtitle && <h4 className="section-subtitle">{homepageSection.subtitle}</h4>}
                  </div>
                  <div className="entity-section-description homepage-section-description-v2">
                    <p>{homepageSection.description}</p>
                  </div>
                  <div className="section-accent" />
                </div>
              ))}
            </div>
            )
            }
            {wedding.owner_first_name && wedding.partner_first_name && wedding.enable_seal && (
            <SealSection topSeal={false} wedding={wedding} />
            )}
          </div>
          {window.zola.env !== 'production' ? (
            <span>
              {page.footer_image_url
                && <div role="img" aria-label={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} className="bottom-section" style={footerStyle} />
              }
            </span>
          ) : (
            <span>
              {page.footer_image_url
                && <div className="bottom-section" style={footerStyle} />
              }
            </span>
          )}
        </div>
        )
        }
      </div>
    );
  }
}

Home.propTypes = {
  homepageSections: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getHomepageSectionEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
    wedding_date: PropTypes.string,
    wedding_account_id: PropTypes.string,
    account_id: PropTypes.string,
    enable_seal: PropTypes.bool,
    city: PropTypes.string,
    state_province: PropTypes.string,
    hashtag: PropTypes.string,
  }).isRequired,
  page: PropTypes.shape({
    title: PropTypes.string,
    header_image_url: PropTypes.string,
    footer_image_url: PropTypes.string,
  }),
  busy: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  homepageSections: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  wedding: ownProps.forPreview ? Object.assign({}, state.wedding.wedding, state.wedding.account) : state.publicWebsite.wedding,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  busy: state.publicWebsite.busy,
});

const mapDispatchToProps = dispatch => ({
  getHomepageSectionEntities: () => dispatch(getWeddingPageByTypeV2('home')),
  unloadEntities: () => dispatch(resetEntities()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Home.jsx